export enum API_URL {
    SDX_REQUEST_URL = '/suppliers/application/request-access/sdx',
    OTM_REQUEST_URL = '/suppliers/application/request-access/otm',
    ARIBA_REQUEST_URL = '/suppliers/application/request-access/ariba',
    CLEAR_ORBIT_REQUEST_URL = '/suppliers/application/request-access/clear-orbit',
    SPT_REQUEST_URL = '/suppliers/application/request-access/spt',
    APSS_REQUEST_URL = '/suppliers/application/request-access/apss',
    MTA_REQUEST_URL = '/suppliers/application/request-access/mta',
    RENTT_REQUEST_URL = '/suppliers/application/request-access/ren-tt',
    RENTM_REQUEST_URL = '/suppliers/application/request-access/ren-tm',
    INTELEX_SUPPLIER_AUDIT_REQUEST_URL = '/suppliers/application/request-access/intelex-supplier-audit',
    QUALITY_SUITES_REQUEST_URL = '/suppliers/application/request-access/quality-suites',
    GE_TAG_REQUEST_FORM = '/suppliers/application/request-access/supplier-ge-id-tag',
    GE_TAG_REQUEST_FORM_FILE_UPLOAD = '/file-upload/uploadFile',
    GE_TAG_REQUEST_RECORDS = '/ge-tag-id/request-access/all-records',
    GE_TAG_REQUEST_RECORDS_EXPORT = '/ge-tag-id/request-access/export-data',
    GE_TAG_REQUEST_UPDATE_RECORD = '/ge-tag-id/request-access/update-record',
    GE_TAG_REQUEST_URL = '/suppliers/application/request-access/ge-tag-id-request',
    GE_TAG_RETURN_URL = '/ge-tag-id/request-access/sent-back-requests',
    GE_TAG_GET_REQUEST = '/ge-tag-id/request-access/get-record',
    SSO_URL = '/suppliers/application/request-access/search/sso',
    SUPPLIER_CONNECT_REQUEST_URL = '/suppliers/application/request-access/supplier-connect',
    ISUPPLIER_REQUEST_URL = '/suppliers/application/request-access/races-isupplier',
    USER_PROFILE_URL = '/user/profile',
    USER_PROFILE_OPERATOR_URL = '/role-management/operator-info',
    APPLICATION_TRAINING_URL = '/application/training',
    RESOURCE = '/resource',
    WIKI_URL = '/server/wiki',
    SRM_SECTION = '/application/link/sections',
    SRM_WELCOME_MESSAGE = '/application/link/welcome-message',
    SRM_LANDINGPAGE = '/application/link/landing-page',
    SRM_APPLICATION_LINK = '/application/link',
    USER_SUPPLIER = '/suppliers',
    NEWS = '/news',
    GLSINFO = '/gsl/search',
    SEARCH = '/search',
    PUBLISH = '/publish',
    SCORE_CARD = '/score-card',
    APPLICATION_ACCESS = '/application-access',
    REVOKE_ACCESS = '/revoke',
    ROLE_MANAGEMENT = '/role-management',
    CONTRACT_ROLE_MANAGEMENT = '/contract-role-management',
    DOCSTORE_ROLE_MANAGEMENT = '/docstore-role-management',
    REVOKE_REQUEST = '/application-integration/revoke-request',
    ACCESS_REQUEST = '/application-integration/access-request',
    ASSIGNMENT_GROUP = '/service-now/assignment-group',
    ACCESS_ASSIGNMENT_GROUP = '/ge-tag-id/request-access/get-assignment-group',
    UPDATE_ASSIGNMENT_GROUP = '/ge-tag-id/request-access/update-assignment-group',
    CONFIDENTIAL = '/confidential-document',
    STAY_INFORMED = '/stay-informed',
    SCORECARD_SETTING = '/kpi-configuration',
    LOW_PERFORMANCE = '/low-performing-supplier',
    SUPPORT_CENTRAL_SDR_CREATE = 'https://app.sc.ge.com/webhooks/integrations/v1/webhook-triggers/api-keys/tXxtZGa72SGeQISnayEzERmXJajmk2mWo4NMJd4druU=',
    SUPPORT_CENTRAL_SDR_SYNC = 'https://app.sc.ge.com/webhooks/integrations/v1/webhook-triggers/api-keys/4SSqy4YaR8aR8g4d0cKaOmjIGZIUl7PwGYCFYCwsikQ=',
    SUPPORT_CENTRAL_INTELEX_CREATE = 'https://app.sc.ge.com/webhooks/integrations/v1/webhook-triggers/api-keys/J75s8gX54Gw7SM8H1aaEbq0auHd076hIkcyvLPJUlrg=',
    SUPPLIER_FORM = '/eol/eol-setup/supplier-forms',
    FIBERGLASS_PROCESSING_FORM = '/eol/eol-setup/field-glass-forms',
    RECYLING_FORM = '/eol/eol-forms/recycling-forms',
}

